import React from "react";
import MediaQuery from "react-responsive";
const breakpoints = {
  desktop: "(min-width: 1200px)",
  tablet: "(min-width: 300px) and (max-width: 1199px)",
  phone: "(max-width: 767px)",
};
// const { string, object } = React.PropTypes;
export default function Breakpoint(props) {
  const breakpoint = breakpoints[props.name] || breakpoints.desktop;
  return (
    <MediaQuery {...props} query={breakpoint}>
      {props.children}
    </MediaQuery>
  );
}
// React.propTypes = {
//   name: string,
//   children: object,
// };
